<template>
  <div>
    <!-- <v-row class="row-menu-right mb-3 pl-3 pr-3">
      <v-btn
        rounded
        color="success"
        dark
        class="mr-2"
        @click="gotocreate"
      >
      <v-icon left dark color="white">fa-plus-circle</v-icon>
      เพิ่มสิทธิ์
      </v-btn>
    </v-row> -->
    <OverlayLoading :loading="loading" />
    <div>
      <v-data-table
        :headers="headers"
        :items="lineworkData"
        class="border-table-employee text-no-wrap mt-1"
        item-key="_id"
        :expanded.sync="expanded"
        :loading="loading"
        loading-text="Loading... Please wait"
        :server-items-length="total || -1"
        @update:items-per-page="changePerPage"
        @update:page="changePage"
        disable-sort
        :page.sync="page"
        :items-per-page="total"
        hide-default-footer
        @page-count="pageCount = $event"
      >
        <template v-slot:[`item.no`]="{ item }">
          {{ (perPage*(page-1)) + lineworkData.indexOf(item)+1 }}
        </template>
        <template v-slot:[`item.name`]="{ item }">
          <span>{{item.name || '-'}}</span>
        </template>
        <template v-slot:[`item.typeName`]="{ item }">
          <span>{{item.typeName || '-'}}</span>
        </template>
        <template v-slot:[`item.createBy`]="{ item }">
          <span>{{item.createBy || '-'}}</span>
        </template>
        <template v-slot:[`item.createAt`]="{ item }">
          <span>{{item.createAt || '-'}}</span>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                rounded
                color="#2BA197"
                dark
                icon
                class="ra-border-button mt-3 mb-3"
                @click="gotoEdit(item)"
              >
              <v-icon color="#2BA197" small>mdi-pencil-outline</v-icon>
              </v-btn>
            </template>
            <span class="label-table-action">จัดการตำแหน่งงาน</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                rounded
                color="#FFB300"
                dark
                icon
                class="ra-border-button mt-3 mb-3 ml-2"
                @click="checkDelPosition(item._id), dialogConfirm === true"
              >
              <v-icon color="error" small>mdi-delete-outline</v-icon>
              </v-btn>
            </template>
            <span class="label-table-action">ลบตำแหน่งงาน</span>
          </v-tooltip>
        </template>
        <template v-slot:item.data-table-expand="{ expand, isExpanded, item }">
          <v-row class="d-flex px-4">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  rounded
                  color="#2BA197"
                  dark
                  icon
                  class="ra-border-button mt-3 mb-3"
                  @click="gotoEdit(item)"
                >
                <v-icon color="#2BA197" small>mdi-pencil-outline</v-icon>
                </v-btn>
              </template>
              <span class="label-table-action">จัดการตำแหน่งงาน</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  rounded
                  color="#FFB300"
                  dark
                  icon
                  class="ra-border-button mt-3 mb-3 ml-2"
                  @click="checkDelPosition(item._id), dialogConfirm === true"
                >
                <v-icon color="error" small>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
              <span class="label-table-action">ลบตำแหน่งงาน</span>
            </v-tooltip>
          </v-row>
        </template>
      </v-data-table>
      <v-row>
      <v-col cols="12" class="pa-0">
      <div class="justify-end d-flex align-end pt-4">
        <v-pagination
          v-model="page"
          :length="pageCount"
          :total-visible="5"
        ></v-pagination>
      </div>
      </v-col>
    </v-row>
    </div>
    <v-dialog v-model="dialogConfirm" max-width="500px">
      <v-card height="170px">
        <v-card-title class="ra-head-text-bold justify-center pa-5">ต้องการลบข้อมูลนี้ ใช่หรือไม่?</v-card-title>
        <v-card-text class="justify-center text-center">
        <span class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการลบข้อมูลนี้</span>
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn class="ra-button1" color="#1654C6" outlined @click="dialogConfirm = false">ยกเลิก</v-btn>
          <v-btn class="ra-button1" color="#1654C6" dark @click="delPermission()">ยืนยัน</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="text-center">
      <v-row>
        <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
        :color="snackbarColor"
        text
        top
        app
        >
        <v-icon left dark small :color="snackbarColor">fa-check-circle</v-icon>
        <span :style="{ 'color': `${snackbarColor}` }">{{ text }}</span>
        </v-snackbar>
      </v-row>
    </div>
  </div>
</template>

<script>
import { getSelectRole, getRoleList, deletePermission } from '@/API/API'
// import { OverlayLoading } from '@/components/index'
import moment from 'moment'
import OverlayLoading from '../../_template/OverlayLoading.vue'
import { EventBus } from '@/EventBus'
import swal from 'sweetalert'

export default {
  components: {
    OverlayLoading
  },
  data () {
    return {
      expanded: [],
      snackbar: false,
      timeout: 2000,
      snackbarColor: '',
      text: '',
      dialogConfirm: false,
      delConfirmId: '',
      keywordRoleName: [],
      keywordRoleType: [],
      loading: true,
      total: -1,
      perPage: 15,
      pageCount: 0,
      page: 1,
      canSave: false,
      headers: [
        {
          text: 'ลำดับ',
          align: 'center',
          value: 'no',
          width: '65',
          sortable: false
        },
        { text: 'ชื่อ', value: 'name' },
        { text: 'ประเภท', value: 'typeName' },
        { text: 'ผู้สร้าง', value: 'createBy' },
        { text: 'วันที่สร้าง', value: 'createAt' },
        { text: 'จัดการ', value: 'data-table-expand', sortable: false, width: '130px', align: 'center fixed', class: 'column-fix' }
      ],
      mockup: [],
      selectData: [],
      lineworkData: []
    }
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
    try {
      this.initData()
    } catch (error) {
    } finally {
      // this.loading = false
    }
  },
  mounted () {
    EventBus.$on('filterPosition', this.getSelect)
  },
  methods: {
    changePerPage (value) {
      this.perPage = value
      this.initDataTable()
    },
    changePage (value) {
      this.page = value
      this.initDataTable()
    },
    getSelect (data) {
      // console.log('Get Select Data Agency', data)
      this.keywordRoleName = data.roleName
      this.keywordRoleType = data.roleType
      this.initDataTable()
    },
    initData () {
      this.initSelectData()
      this.initDataTable()
    },
    async initSelectData () {
      this.loading = true
      this.selectData = []
      const token = this.tokenUser
      try {
        const res = await getSelectRole(token)
        if (res.success) {
          // if (res.result.length) {
          this.selectData = res.result
          EventBus.$emit('getFilterPosition', this.selectData)
          EventBus.$emit('selectRole', res.result)
          // }
          // console.log(res)
        } else {
          // console.log(res)
        }
      } catch (error) {
        // alert(error)
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async initDataTable () {
      this.loading = true
      this.lineworkData = []
      const temp = []
      var obj = {
        // name: this.keywordRoleName,
        // type: this.keywordRoleType,
        permissionId: this.keywordRoleName,
        permissionTypeId: this.keywordRoleType,
        limit: this.perPage,
        page: this.page
      }
      const token = this.tokenUser

      try {
        const res = await getRoleList(obj, token)
        if (res.success) {
          if (res.result.length) {
            res.result.map((el, index) => {
              el.createAt = this.initDate(el.createAt)
              temp.push({
                no: index + 1,
                ...el
              })
            })
          }
          this.total = res?.count || -1
          this.lineworkData = temp
        } else {
          // console.log(res)
        }
      } catch (error) {
        // alert(error)
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    manageLineWork (data) {
      // console.log('manage line work', data)
    },
    checkDelPosition (id) {
      this.delConfirmId = ''
      this.delConfirmId = id
      this.dialogConfirm = true
      // var delId = id
      // swal('ต้องการลบข้อมูลนี้ ใช่หรือไม่!', {
      //   buttons: {
      //     cancel: 'ยกเลิก',
      //     catch: {
      //       text: 'ใช่',
      //       value: 'save'
      //     }
      //   }
      // })
      //   .then((value) => {
      //     switch (value) {
      //       case 'save':
      //         this.delPermission(delId)
      //         break
      //       default:
      //         swal('คำเตือน', 'ข้อมูลยังไม่ถูกลบ', 'warning', {
      //           button: false,
      //           timer: 2000
      //         })
      //     }
      //   })
    },
    async delPermission () {
      this.loading = true
      const obj = {
        _id: this.delConfirmId
      }
      try {
        const res = await deletePermission(obj, this.tokenUser)
        if (res.success) {
          swal('สำเร็จ', 'ลบข้อมูลสำเร็จ', 'success', {
            button: false,
            timer: 2000
          }).then()
          this.initData()
          this.resetFilter()
          this.dialogConfirm = false
          this.delConfirmId = ''
        } else {
          swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
            button: false,
            timer: 2000
          })
          this.dialogConfirm = false
          this.delConfirmId = ''
        }
      } catch (error) {
        console.log(error)
        swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
          button: false,
          timer: 2000
        })
        this.dialogConfirm = false
        this.delConfirmId = ''
      } finally {
        this.loading = false
      }
    },
    resetFilter () {
      this.keywordRoleName = []
      this.keywordRoleType = []
    },
    initDate (date) {
      return moment(date).format('DD/MM/YYYY HH:mm น.')
    },
    gotocreate () {
      this.$router.push('managerole/create')
    },
    gotoEdit (data) {
      // this.$router.push('manageposition/update')
      this.$router.push('managerole/update/' + data._id)
      // this.$router.push({
      //   name: 'manageRoleUpdate',
      //   params: {
      //     item: data,
      //     id: data._id
      //   }
      // })
    }
  }
}
</script>

<style>
/* table */
.theme--light.v-pagination .v-pagination__item--active {
    background: #2BA197 !important;
    color: #FFFFFF;
}
.v-pagination__item {
    background: transparent;
    border-radius: 4px;
    font-size: 14px;
    height: 30px;
    margin: 0.3rem;
    min-width: 30px;
    padding: 0 5px;
    text-decoration: none;
    transition: 0.3s cubic-bezier(0, 0, 0.2, 1);
    width: auto;
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
}
.v-pagination__navigation {
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    height: 30px;
    width: 30px;
    margin: 0.3rem 10px;
}
/* end */
.border-table-employee {
  border-radius: 10px;
  border: 1px solid rgb(229, 236, 238);
}

table > tbody > tr > td.fixed:nth-last-child(1),
table > thead > tr > th.fixed:nth-last-child(1) {
  position: sticky !important;
  position: -webkit-sticky !important;
  right: 0;
  /* z-index: 9997; */
  background: white;
  /* background: transparent; */
  -webkit-box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
  -moz-box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
  box-shadow: -1px 0px 3px -1px rgba(0, 0, 0, 0.19);
}

table > tbody > tr:hover > td.fixed:nth-last-child(1), table > thead > tr:hover > th.fixed:nth-last-child(1) {
  background: #eeeeee;
}

table > thead > tr > th.fixed:nth-last-child(1) {
  /* z-index: 9998; */
  background-color: #F8F9FB;
}

</style>
<style>
.v-data-table {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 16px;
}
.row-menu-left {
  justify-content: flex-start !important;
}
.row-menu-right {
  justify-content: flex-end !important;
}
.v-data-table tbody tr.v-data-table__expanded__content {
  box-shadow: inset 0px 4px 8px -5px rgba(50, 50, 50, 0), inset 0px -4px 8px -5px rgba(50, 50, 50, 0) !important;
}
.padding-left-90 {
  padding-left: 90px !important;
}
.table-name-row {
  display: flex;
  flex-direction: row;
}
.btn-edit-dep {
  background-color: #0370B7 !important;
  color: #fff !important;
}
.btn-del-dep {
  background-color: #da2525 !important;
  color: #fff !important;
}
</style>
